import { sdk } from "@/lib/medusa";

function normalizeEmail(email) {
  return String(email || "").trim().toLowerCase();
}

function isExistingIdentityError(error) {
  const message = String(error?.message || "").toLowerCase();
  return message.includes("already") || message.includes("exists") || message.includes("identity");
}

export async function retrieveCustomer() {
  try {
    const { customer } = await sdk.store.customer.retrieve();
    return customer || null;
  } catch {
    return null;
  }
}

export async function loginCustomer({ email, password }) {
  const result = await sdk.auth.login("customer", "emailpass", {
    email: normalizeEmail(email),
    password,
  });

  if (result && typeof result === "object") {
    if (result.verification_required) {
      throw new Error("Please verify your email before signing in to your account.");
    }

    if (result.location) {
      window.location.href = result.location;
      return null;
    }
  }

  const { customer } = await sdk.store.customer.retrieve();
  return customer || null;
}

export async function registerCustomer({ firstName, lastName, email, phone, password }) {
  const normalizedEmail = normalizeEmail(email);
  let registrationToken = "";

  try {
    const response = await sdk.client.fetch("/auth/customer/emailpass/register", {
      method: "POST",
      body: {
        email: normalizedEmail,
        password,
      },
    });

    registrationToken = response?.token || (typeof response === "string" ? response : "");
  } catch (error) {
    if (!isExistingIdentityError(error)) throw error;

    const response = await sdk.client.fetch("/auth/customer/emailpass", {
      method: "POST",
      body: {
        email: normalizedEmail,
        password,
      },
    });

    registrationToken = response?.token || (typeof response === "string" ? response : "");
  }

  if (!registrationToken) {
    throw new Error("Medusa did not return a customer registration token.");
  }

  const customerResponse = await sdk.client.fetch("/store/customers", {
    method: "POST",
    headers: {
      Authorization: `Bearer ${registrationToken}`,
    },
    body: {
      email: normalizedEmail,
      first_name: String(firstName || "").trim(),
      last_name: String(lastName || "").trim(),
      phone: String(phone || "").trim() || undefined,
    },
  });

  if (!customerResponse?.customer?.id) {
    throw new Error("Customer account could not be created.");
  }

  const loginResult = await sdk.auth.login("customer", "emailpass", {
    email: normalizedEmail,
    password,
  });

  if (loginResult && typeof loginResult === "object" && loginResult.verification_required) {
    throw new Error("Please verify your email before signing in to your account.");
  }

  const { customer } = await sdk.store.customer.retrieve();

  if (!customer?.id) {
    throw new Error("Your account was created, but the customer session could not be started.");
  }

  return customer;
}

export async function logoutCustomer() {
  await sdk.auth.logout();
}
